<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Subir Estudiantes
  </h2>
  <button
    type="button"
    class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    (click)="goBack()"
  >
    Volver
  </button>
  <!-- Sección de advertencias mejorada -->
<div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-4">
  <h2 class="text-xl font-semibold text-yellow-700 mb-4">
    ⚠️ Información Importante
  </h2>

  <!-- Lista de instrucciones -->
  <div class="space-y-3">
    <!-- Instrucción 1: Descargar plantilla -->
    <div class="bg-yellow-100 p-3 rounded-lg">
      <p class="text-base font-medium text-yellow-800">
        • Descarque y verifique el formato de la plantilla de Estudiantes
        <a
          href="https://backprod.devcorehub.com/documentos/example_students.xlsx"
          target="_blank"
          class="text-blue-600 underline hover:text-blue-800"
        >
          Descargar Formato
        </a>
      </p>
    </div>

    <!-- Instrucción 2: Formato del archivo -->
    <div class="bg-yellow-100 p-3 rounded-lg">
      <p class="text-base font-medium text-yellow-800">
        • Debe subir el archivo de estudiantes en formato Excel
        (.xlsx, .xls).
      </p>
    </div>

    <!-- Instrucción 3: Resultados de la carga -->
    <div class="bg-yellow-100 p-3 rounded-lg">
      <p class="text-base font-medium text-yellow-800">
        • Al hacer clic en el botón "Subir Estudiantes", se mostrarán los
        registros exitosos y los fallidos, junto con el motivo del error.
      </p>
    </div>

    <!-- Instrucción 4: Finalización de la carga -->
    <div class="bg-yellow-100 p-3 rounded-lg">
      <p class="text-base font-medium text-yellow-800">
        • Una vez finalizada la carga de llos estudiantes, le
        recomendamos hacer clic en el botón "Volver".
      </p>
    </div>
  </div>
</div>
  <!-- Formulario para subir archivos -->
  <div class="bg-white p-6 rounded-lg shadow-md">
    <form (ngSubmit)="onSubmit($event)" class="space-y-4">
      <div>
        <label for="fileInput" class="block text-sm font-medium text-gray-700">
          Selecciona un archivo Excel (.xlsx, .xls)
        </label>
        <input
          type="file"
          id="fileInput"
          accept=".xlsx, .xls"
          (change)="onFileChange($event)"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          required
        />
      </div>
      <button
        type="button"
        (click)="onSubmit($event)"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Subir Estudiantes
      </button>
    </form>

    <!-- Resultado de la subida -->
    <div *ngIf="result" class="mt-6 p-4 bg-gray-50 rounded-lg">
      <pre class="text-green-600">EXITOSO: {{ result.mensaje | json }}</pre>
      <pre class="text-red-600">ERRORES: {{ result.errores | json }}</pre>
    </div>

    <!-- Mensaje de error -->
    <div *ngIf="errorMessage" class="mt-6 p-4 bg-red-50 rounded-lg">
      <p class="text-red-600">Puedes seguir intentando</p>
      <p class="text-red-600">{{ errorMessage }}</p>
    </div>
  </div>
</div>

